import { deleteUser } from './deleteUser/deleteUser'
import editUser from './editUser/editUser'
import getUsers from './getUsers/getUsers'
import createUser from './createUser/createUser'
import verifyUser from './verifyUser/verifyUser'

export default {
  getUsers,
  createUser,
  editUser,
  deleteUser,
  verifyUser
}
